// extracted by mini-css-extract-plugin
export default {"CompactMenu":"style_CompactMenu__RZ2dD","CompactMenu__flexCon":"style_CompactMenu__flexCon__zJ8yk","CompactMenu__exploreBtn":"style_CompactMenu__exploreBtn__z4937"};